module.exports = __webpack_public_path__ + "img/playstation.6c922a5e.svg";